import gql from 'graphql-tag'

export default gql`
    mutation SendVZFMail($vzfID: String!, $email: String!, $clientID: Int) {
        sendVZFMail(vzfID: $vzfID, email: $email, clientID: $clientID) {
            status
        }
    }
`
